/**
 * Slick Carousel init.
 *
 * ⚠️ Slick жёстко зависим от jQuery — поэтому эта обёртка тоже остаётся на $.
 * Плановая миграция: Slick → Swiper.js (Swiper.js не требует jQuery).
 * До миграции этот файл — единственное легитимное место использования jQuery на фронте.
 */

const NAV_ARROWS = {
    NEXT: '<div class="gallery_nav_arrow_prev"><img src="/img/arrows/slider_arrow_prev.svg" alt=""></div>',
    PREV: '<div class="gallery_nav_arrow_next"><img src="/img/arrows/slider_arrow_next.svg" alt=""></div>',
};

const RESPONSIVE_PARAMS = [
    {
        breakpoint: 1024,
        settings: { slidesToShow: 2, slidesToScroll: 1, dots: true, arrows: false },
    },
    {
        breakpoint: 510,
        settings: { slidesToShow: 1, slidesToScroll: 1, dots: true, arrows: false },
    },
];

const PARAMS_DEFAULT = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: NAV_ARROWS.NEXT,
    nextArrow: NAV_ARROWS.PREV,
    responsive: RESPONSIVE_PARAMS,
};

function initSliders() {
    if (typeof $ === 'undefined' || !$.fn.slick) return;

    // SLIDER - NEW ARRIVALS
    const $s1 = $('#slider_01');
    if ($s1.length) $s1.slick(PARAMS_DEFAULT);

    // SLIDER - YOU MAY LIKE
    const $s2 = $('#slider_02');
    if ($s2.length) $s2.slick(PARAMS_DEFAULT);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
} else {
    initSliders();
}
